/**
 * @desc plm批量保存或者更新sku
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmSkuCreateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/plm/batchCreateOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
